<template>
    <v-autocomplete
        :value="value"
        :items="organized_font_families"
        :label="label"
        :placeholder="placeholder"
        :dense="dense"
        :outlined="outlined"
        :clearable="clearable"
        :required="required"
        :rules="rules"
        :disabled="disabled"
        :loading="loading || fonts_loading"
        :filter="fontSearchFilter"
        :class="componentClass"
        :style="componentStyle"
        item-text="text"
        :hide-details="hide_details"
        item-value="value"
        :no-data-text="fonts_loading ? 'Loading fonts...' : 'No fonts found'"
        @input="$emit('input', $event)"
    >
        <template #item="{ item }">
            <v-list-item-content
                v-if="item.header"
                class="pa-0"
            >
                <v-subheader class="font-section-header">{{ item.header }}</v-subheader>
            </v-list-item-content>

            <v-list-item-content
                v-else
                class="font-item"
            >
                <v-list-item-title :style="{ fontFamily: item.value }">
                    {{ font_id_names[item.value] || item.text }}
                </v-list-item-title>
            </v-list-item-content>
        </template>

        <template #selection="{ item }">
            <span :style="{ fontFamily: item.value }">{{ font_id_names[item.value] || item.text }}</span>
        </template>
    </v-autocomplete>
</template>

<script>
import fontLoaderMixin from '@/mixins/font-loader';

export default {
    mixins: [fontLoaderMixin],

    props: {
        value: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: 'Font Family',
        },
        placeholder: {
            type: String,
            default: 'Select a font...',
        },
        organizationId: {
            type: String,
            required: true,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
        rules: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        hide_details: {
            type: [Boolean, String],
            default: 'auto',
        },
        componentClass: {
            type: String,
            default: '',
        },
        componentStyle: {
            type: Object,
            default: () => ({}),
        },
    },

    mounted() {
        this.loadFontFamilies(this.organizationId);
    },

    watch: {
        organizationId(newId) {
            if (newId) {
                this.loadFontFamilies(newId);
            }
        },
    },

    methods: {
        refreshFonts() {
            if (this.organizationId) {
                this.loadFontFamilies(this.organizationId);
            }
        },
    },
};
</script>

<style scoped>
.font-section-header {
    font-weight: bold;
    color: #666;
    padding: 8px 16px;
    background-color: #f5f5f5;
    border-bottom: 1px solid #ddd;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.font-item {
    padding: 0.5rem 1rem;
    width: 100%;
}
</style>